export default __webpack_public_path__ + "images/Axial_View_of_Fetal_Bladder.f8598239696de969e16a7a91b520572b.png";